import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles.css";
import "./i18n"; // Initialize i18n before App renders

const container = document.getElementById("root");
const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Use hydrateRoot when the server pre-rendered HTML into #root (faster, no flash).
// Fall back to createRoot for the generic index.html catch-all path.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// Register Service Worker for PWA
// On each page load, ensure old service workers are cleared and the current script is fetched.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        registrations.map(async (reg) => {
          if (reg.active && reg.active.scriptURL !== `${window.location.origin}/sw.js`) {
            await reg.unregister();
          }
        })
      );

      const registration = await navigator.serviceWorker.register("/sw.js");
      console.log("SW registered:", registration);
      if (registration.waiting) {
        // Force the new service worker to take control as soon as possible
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
      await registration.update();
    } catch (registrationError) {
      console.log("SW registration failed:", registrationError);
    }
  });
}

